import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import Slider from 'react-slick';

import * as cartActionCreators from '../../../actions/cart';
let allActionCreators = Object.assign({}, cartActionCreators);

import RhinoSelect from '../../common/inputs/RhinoSelect';

class DiamondBracelets extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
		this.state = {
      price1: 2100,
      price2: 1150,

      carat1: '',
      carat2: '',

      imageIndex1: null,
      imageIndex2: null,

      errorCode: '',

      overrideImage2: false,

      loadingButton: null,
    }

    this.imageList1 = [
      'tennis-square.jpeg',
      'tennis-alt1.jpg',
      'tennis-alt2.jpg',
    ];

    this.imageList2 = [
      'bangle-square.jpg',
      'bangle1.jpg',
      'bangle2.jpg',
    ];
	}

	componentDidMount() {
    document.title = 'Diamonds Direct';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
  }

  getCW1() {
    return [
      {
        display: 'Select Carat Weight',
        value: '',
      },
      {
        display: '1.06 ctw',
        value: 2100,
      },
      {
        display: '2.00 ctw',
        value: 3200,
      },
      {
        display: '3.00 ctw',
        value: 4300,
      },
      {
        display: '4.00 ctw',
        value: 6050,
      },
      {
        display: '5.00 ctw',
        value: 8000,
      },
      {
        display: '6.00 ctw',
        value: 8950,
      },
      {
        display: '7.00 ctw',
        value: 11050,
      },
      {
        display: '8.35 ctw',
        value: 12500,
      },
      {
        display: '10.20 ctw',
        value: 19050,
      },
    ];
  }

  getCW2() {
    return [
      {
        display: 'Select Carat Weight',
        value: '',
      },
      {
        display: '0.35 ctw',
        value: 1150,
      },
      {
        display: '0.59 ctw',
        value: 1490,
      },
      {
        display: '1.00 ctw',
        value: 2480,
      },
      {
        display: '1.50 ctw',
        value: 3150,
      },
      {
        display: '2.00 ctw',
        value: 4130,
      },
      {
        display: '3.00 ctw',
        value: 5720,
      },
      {
        display: '5.20 ctw',
        value: 10600,
      },
    ];
  }

  newTabNav(page) {
  	let win = window.open(page, '_blank');
    win.focus();
  }

  externalNav(page) {
    window.location.href = '/' + page;
  }

  internalNav(page) {
  	this.context.router.push('/' + page);
  }

  openIntercom() {
    acquireIO.max();
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  changeCarat1(evt) {
    this.setState({ 
      carat1: evt.target.value, 
      imageIndex1: this.state.imageIndex1 === null ? 1 : this.state.imageIndex1,
    }, () => {
      if(this.state.errorCode == 'carat1') {
        this.setState({ errorCode: '' });
      }
    });
  }

  changeCarat2(evt) {
    this.setState({ 
      carat2: evt.target.value, 
      imageIndex2: this.state.imageIndex2 === null ? 1 : this.state.imageIndex2,
    }, () => {
      if(this.state.errorCode == 'carat2') {
        this.setState({ errorCode: '' });
      }
    });
  }

  getBraceletImg1(braceletCaratCost) {
    const currentIndex = this.state.imageIndex1 === null ? 0 : this.state.imageIndex1;
    return <img src={`https://ddw2.diamondsdirect.com/img/diamondpages/${this.imageList1[currentIndex]}`} />;
  }

  getBraceletImg2(braceletCaratCost) {
    const currentIndex = this.state.imageIndex2 === null ? 0 : this.state.imageIndex2;
    return <img src={`https://ddw2.diamondsdirect.com/img/diamondpages/${this.imageList2[currentIndex]}`} />;
  }

  getCaratWeight(sku, price) {
    if(!sku) {
      return '';
    }

    let dataBlock = [];

    switch(sku) {
      case 'DBRTB':
        dataBlock = this.getCW1();
        break;
      case 'DBRBB':
        dataBlock = this.getCW2();
        break;
      default:
        dataBlock = this.getCW2();
    }

    for(let i = 0; i < dataBlock.length; i++) {
      if(dataBlock[i].value == price) {
        return dataBlock[i].display;
      }
    }
    return '';
  }

  getBraceletDesc(sku, price, addSku = null) {

    let diaDesc = '';
    let caratWeight = this.getCaratWeight(sku, price);

    if(addSku) {
      diaDesc += ('<B>SKU</B>: ' + addSku + '<br />');
    }
    if(caratWeight) {
      diaDesc += ('<B>Carat Weight</B>: ' + caratWeight + ' (NOTE: The total carat weight displayed may represent a range, actual total carat weight may vary up to 5%)<br />');
    }
    diaDesc += '<B>Metal type</B>: 14 karat white gold<br /><B>Color</B>: The average color range for bracelets is G - H<br /><B>Clarity</B>: The average clarity range for bracelets is SI';
    return diaDesc;
  }

  getASCSkuValue(skuValue) {

    if(skuValue == 'DBRBB' && this.state.carat2) {
      if(this.state.carat2 == 1150) {
        return 'GBANG00736';
      } else if(this.state.carat2 == 1490) {
        return 'GBANG00594';
      } else if(this.state.carat2 == 2480) {
        return 'GBANG00545';
      } else if(this.state.carat2 == 3150) {
        return 'GBANG03077';
      } else if(this.state.carat2 == 4130) {
        return 'GBANG02332';
      } else if(this.state.carat2 == 5720) {
        return 'GBANG03083';
      } else if(this.state.carat2 == 10600) {
        return 'GBANG00554';
      } else {
        return skuValue;
      }
    }
    return skuValue;
  }

  addToCart(sku, caratPrice, code) {

    if(!this.state[code]) {
      this.setState({ errorCode: code });
      return;
    }

    this.setState({ loadingButton: code });

    console.log(this.getASCSkuValue(sku));
    const modifiedSku = this.getASCSkuValue(sku);

    if(sku !== modifiedSku) {
      this.props.cartGuestAddItem(modifiedSku, this.getBraceletDesc(sku, caratPrice, modifiedSku), caratPrice)
      .then((resp) => {
        console.log(resp);
        this.externalNav('checkout/cart');
      })
      .catch((errResp) => {
        this.setState({ loadingButton: null });
      });
    } else {
      // export function cartAddDiamondJewelry(stockNo, sku, carat_mod, diamond_desc) {
      this.props.cartAddDiamondJewelry(modifiedSku, caratPrice, this.getBraceletDesc(sku, caratPrice))
      .then((resp) => {
        console.log(resp);
        this.externalNav('checkout/cart');
      })
      .catch((errResp) => {
        this.setState({ loadingButton: null });
      });
    }
  }

  getToggleStyle(orderPrice, suffix) {
    if(!orderPrice) {
      return {};  
    } else {
      return {
        display: 'block',
      }
    }
  }

  increaseImageIndex1() {
    const nextIndex = this.state.imageIndex1 === null ? 1 : this.state.imageIndex1 + 1;
    this.setState({ imageIndex1: nextIndex >= this.imageList1.length ? 0 : nextIndex });
  }

  increaseImageIndex2() {
    const nextIndex = this.state.imageIndex2 === null ? 1 : this.state.imageIndex2 + 1;
    this.setState({ imageIndex2: nextIndex >= this.imageList2.length ? 0 : nextIndex });
  }

  render() {
    return <div className='DiamondBracelets DiamondPage'>

      <link rel='preload' href='https://ddw2.diamondsdirect.com/img/diamondpages/products2/tennis-alt1.jpg' as='image' />
      <link rel='preload' href='https://ddw2.diamondsdirect.com/img/diamondpages/products2/tennis-alt2.jpg' as='image' />

      <div className='dpBreadcrumbs'>Diamond Bracelets</div>
      <div className='dpProductsWrapper'>
        <div className='dpProduct'>
          <div className='dpItemWrapper'>
            <div className={'dpProductImg braceletImg'}>
              {this.getBraceletImg1(this.state.carat1)}
              <div className='imageToggle' style={this.getToggleStyle(this.state.carat1, '1')} onClick={() => this.increaseImageIndex1()}>
                <i className="fas fa-exchange-alt"></i>
              </div>
            </div>
            <div className='dpProductTitle'>Tennis Bracelet</div>
            <div className='dpProductConfigElement'>
              {this.state.errorCode == 'carat1' ?
                <div className='dpErrorMessage'>Please select a carat weight</div> :
                null
              }
              <RhinoSelect
                options={this.getCW1()}
                value={this.state.carat1}
                changeMethod={::this.changeCarat1}
                rootClass='productSelect' />
            </div>
            <div className='dpBr'></div>
            <div className='dpPrice'>${(this.state.carat1 ? this.state.carat1 : this.state.price1).toLocaleString()}</div>
            {this.state.loadingButton == 'carat1' ?
              <div className='dpAddToCart dpLoading'><div><i className="fas fa-spinner fa-pulse"></i>&nbsp;&nbsp;&nbsp;Adding to Cart</div></div> :
              <div className='dpAddToCart' onClick={() => this.addToCart('DBRTB', this.state.carat1 ? this.state.carat1 : this.state.price1, 'carat1')}><div>Add to Cart</div></div>
            }
          </div>
        </div>

        <div className='dpProduct'>
          <div className='dpItemWrapper'>
            <div className={'dpProductImg braceletImg'}>
              {this.getBraceletImg2(this.state.carat2)}
              <div className='imageToggle' style={this.getToggleStyle(this.state.carat2, '2')} onClick={() => this.increaseImageIndex2()}>
                <i className="fas fa-exchange-alt"></i>
              </div>
            </div>
            <div className='dpProductTitle'>Bangle Bracelet</div>
            <div className='dpProductConfigElement'>
              {this.state.errorCode == 'carat2' ?
                <div className='dpErrorMessage'>Please select a carat weight</div> :
                null
              }
              <RhinoSelect
                options={this.getCW2()}
                value={this.state.carat2}
                changeMethod={::this.changeCarat2}
                rootClass='productSelect' />
            </div>
            <div className='dpBr'></div>
            <div className='dpPrice'>${(this.state.carat2 ? this.state.carat2 : this.state.price2).toLocaleString()}</div>
            {this.state.loadingButton == 'carat2' ?
              <div className='dpAddToCart dpLoading'><div><i className="fas fa-spinner fa-pulse"></i>&nbsp;&nbsp;&nbsp;Adding to Cart</div></div> :
              <div className='dpAddToCart' onClick={() => this.addToCart('DBRBB', this.state.carat2 ? this.state.carat2 : this.state.price2, 'carat2')}><div>Add to Cart</div></div>
            }
          </div>
        </div>

      </div>
      <div className='dpLegal'>*Please note: All diamond bracelets are set in 14 karat white gold.<br />The average color range is G - H and the average clarity range is SI<br />The total carat weight displayed may represent a range, actual total carat weight may vary up to 5%.<br />The standard length of the Tennis Bracelet is seven inches.<br />Carat weight reflects the amount of diamonds around the bangle. Some bangles may appear smaller due to the metal to diamond ratio.</div>
      <div className='braceletsCustomSection'>
        <div className='scWrapper'>
          <div className='braceletsCustomRight'>
            <div className='scTitle'>Custom Bracelets</div>
            <div className='scBody'>Diamonds Direct can handcraft a diamond bracelet to meet any expectations! For certified diamonds, fancy colors, or fancy shape diamonds our diamond experts can help select diamonds to make the perfect bracelet.</div>
            <div className='scButtonWrapper' onClick={() => this.internalNav('custom-design')}>
              <div className='scButton'>Create Custom</div>
            </div>
          </div>
        </div>
      </div>
    </div>;
	}
}
export default DiamondBracelets;

function mapStateToProps(state) {
  return {

  };
}

export const DiamondBraceletsContainer = connect(
  mapStateToProps,
  allActionCreators
)(DiamondBracelets);


// WEBPACK FOOTER //
// ./src/components/views/diamondpages/DiamondBracelets.jsx